export default __webpack_public_path__ + "static/media/car2.d8dce9f5.jpg";